import { IS_IOS } from "../config";
import { Capacitor } from "@capacitor/core";

const INTERSTITIAL_AD_ID = __DEV__
  ? "ca-app-pub-3940256099942544/8691691433"
  : IS_IOS
  ? "ca-app-pub-6233263635773218/7518262905"
  : "ca-app-pub-6233263635773218/6086791387";

const REWARD_AD_ID = __DEV__
  ? "ca-app-pub-3940256099942544/5224354917"
  : IS_IOS
  ? "ca-app-pub-6233263635773218/3579017895"
  : "ca-app-pub-6233263635773218/7041681418";

class AdManager {
  constructor() {
    this.preparedInterstitial = false;
    this.preparedReward = false;
  }

  async prepareAd(AdMob, type) {
    const preparedFlag =
      type === "Interstitial" ? "preparedInterstitial" : "preparedReward";
    const adId = type === "Interstitial" ? INTERSTITIAL_AD_ID : REWARD_AD_ID;
    const method =
      type === "Interstitial"
        ? AdMob.prepareInterstitial
        : AdMob.prepareRewardVideoAd;

    if (Capacitor.getPlatform() === "web") return;

    if (!this[preparedFlag]) {
      await method({
        adId,
        isTesting: __DEV__,
      });
      this[preparedFlag] = true;
    }
  }

  async showAd(AdMob, type) {
    const preparedFlag =
      type === "Interstitial" ? "preparedInterstitial" : "preparedReward";
    const method =
      type === "Interstitial"
        ? AdMob.showInterstitial
        : AdMob.showRewardVideoAd;

    await method();
    this[preparedFlag] = false;
  }
}

const adManager = new AdManager();

export default adManager;
